import React, {Component} from 'react';
import styles from './bonusCard.module.scss';
import {inject, observer} from "mobx-react";
import {BONUS_CARD_STATUSES} from "../../../entities/bonus_card";
import UiStore from "../../../stores/UiStore";
import {BonusCardModel} from "./model";
import Link from 'next/link';
import {sendMetrics} from "../../../utils/misc";


@inject('uiStore')
@observer
export default class BonusCardMobile extends Component<any, BonusCardModel> {
  props: {
    info: BonusCardModel;
    showStatus?: boolean;
    uiStore?: UiStore;
    metricsOnClick?: string;
  };

  render() {
    const {info, showStatus = true, metricsOnClick} = this.props
    const isSquare = info.w / info.h === 1
    return (
      <Link href={`/bonus/${info.id}`}>
        <div className={styles.BonusCardMobile}
             onClick={metricsOnClick ? () => sendMetrics(metricsOnClick) : null}>
          {showStatus && info.status && <div className={styles.BonusCardMobileStatus}>
              <img src={BONUS_CARD_STATUSES[info.status].icon} alt={info.status}/>
          </div>}
          <div className={styles.BonusCardMobileContent}>
            <div className={styles.BonusCardMobileContentLogo}>
              <img src={info.partnerImage} alt={info.partnerImage}
                   style={isSquare ? {width: '48px', height: '48px'} : null}/>
            </div>
            <div className={styles.BonusCardMobileContentText}>
              <span className={styles.BonusCardMobileContentTextName}>{info.partnerName}</span>
              <span className={styles.BonusCardMobileContentTextTitle}>{info.bonusName}</span>
              <span className={styles.BonusCardMobileContentTextDate}>{info.dateValidityBeautify}</span>
            </div>
          </div>
        </div>
      </Link>
    )
  }
}
